window.addEventListener('load', () => {
  const minDesktopWidth = 768;

  // Skip if device is smaller than desktop
  if (window.innerWidth < minDesktopWidth) return;

  // Also skip if user has Data Saver turned on
  if ('connection' in navigator && navigator.connection.saveData) return;

  const hoverBoxes = document.querySelectorAll('[data-hover-image]');

  hoverBoxes.forEach(box => {
    const src = box.dataset.hoverImage;
    if (!src) return;

    const img = new Image();
    img.decoding = 'async';
    img.loading = 'eager';
    img.src = src;

    // Optional: inject into hidden <img> if present
    const imgEl = box.querySelector('[data-hover-img]');
    if (imgEl) {
      imgEl.src = src;
      imgEl.style.opacity = '';
      imgEl.style.pointerEvents = '';
      imgEl.removeAttribute('aria-hidden');
    }
  });
});